<template>
  <!-- 蓝色背景信息栏 -->
  <div class="contact-bar">
    <div class="nav">
      <div class="nav-left">
        <span class="contact-text">
          <img src="@/assets/image/信封.png" alt="" class="img"> in_eying@163.com
        </span>
        <span class="contact-text">
          <img src="@/assets/image/电话.png" alt="" class="img"> 0535-3931271
        </span>
        <span class="contact-text">
          <img src="@/assets/image/地址.png" alt="" class="img"> 2090 Fasan Dr, Oldcastle, ON N0R 1L0
        </span>

      </div>

      <div class="nav-right">
        <span>关注我们</span>
        <router-link to="/"><img src="@/assets/image/首页.png" alt="" class="img" style="margin-top: 5px;"></router-link>
        <router-link to="/medical"><img src="@/assets/image/产品.png" alt="" class="img" style="margin-top: 5px;"></router-link>
        <router-link to="/people"><img src="@/assets/image/招聘.png" alt="" class="img" style="margin-top: 5px;"></router-link>
        <router-link to="/contact"><img src="@/assets/image/联系.png" alt="" class="img" style="margin-top: 8px;"></router-link>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ContactBar'
}
</script>

<style scoped>
.contact-bar {
  width: 100%;
  /* 蓝色背景，可自行更换色值 */
  background-color: #ccc;
  height: 60px;
  box-sizing: border-box;
}

.nav {
  width: 90%;
  height: 100%;
  margin: auto;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.nav-left {
  width: 60%;
  display: flex;
  justify-content: space-evenly;
  align-items: center;
  /* line-height: 60px; */
}

.nav-right {
  width: 20%;
  display: flex;
  justify-content: space-around;
  align-items: center;
  color: #ffffff;
}

.contact-text {
  color: #ffffff;
  font-size: 16px;
  letter-spacing: 0.5px;
  display: flex;
  justify-content: space-evenly;
  align-items: center;
}

.img {
  width: 20px;
  margin-right: 10px;
}
</style>